<template>
  <div class="user-verifications app__block">
    <div class="app-list">
      <template v-if="isLoaded && verificationsList.length && !isFailed">
        <template v-if="pendingVerifications.length">
          <h3
            class="user-verifications__list-title">
            {{ 'user-verifications.pending-verifications' | globalize }}
          </h3>
          <div class="app-list__header">
            <span class="app-list__cell app-list__cell--left">
              {{ "user-verifications.lbl-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-verifications.lbl-user-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-verifications.lbl-status" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "user-verifications.lbl-type" | globalize }}
            </span>
          </div>
          <button
            class="app-list__li"
            v-ripple
            v-for="item in pendingVerifications"
            :key="`user-verifications-${item.id}`"
            @click="redirectToVerificationDetails(item.id)"
          >
            <span
              class="app-list__cell app-list__cell--left"
              :title="item.id"
            >
              <copyable :copy-text="item.id.toString()">
                {{ item.id }}
              </copyable>
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.userId"
            >
              <copyable :copy-text="item.userId.toString()">
                {{ item.userId }}
              </copyable>
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.status"
            >
              {{ item.status | formatVerificationStatus }}
            </span>

            <span
              class="app-list__cell app-list__cell--right"
              :title="item.type"
            >
              {{ item.type | formatVerificationType }}
            </span>
          </button>
        </template>

        <template v-if="verificationsList.length">
          <h3
            v-if="verificationsList.length"
            class="user-verifications__list-title"
            :class="['user-verifications__list-title__top-padded']">
            {{ 'user-verifications.all-verifications' | globalize }}
          </h3>
          <div class="app-list__header">
            <span class="app-list__cell app-list__cell--left">
              {{ "user-verifications.lbl-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-verifications.lbl-user-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-verifications.lbl-status" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "user-verifications.lbl-type" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "verifications-list.lbl-created" | globalize }}
            </span>
          </div>
          <button
            class="app-list__li"
            v-ripple
            v-for="item in verificationsList"
            :key="`user-verifications-${item.id}`"
            @click="redirectToVerificationDetails(item.id)"
          >
            <span
              class="app-list__cell app-list__cell--left"
              :title="item.id"
            >
              <copyable :copy-text="item.id.toString()">
                {{ item.id }}
              </copyable>
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.userId"
            >
              <copyable :copy-text="item.userId.toString()">
                {{ item.userId }}
              </copyable>
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.status"
            >
              {{ item.status | formatVerificationStatus }}
            </span>
            <span
              class="app-list__cell app-list__cell--right"
              :title="item.type"
            >
              {{ item.type | formatVerificationType }}
            </span>
            <span
              class="app-list__cell app-list__cell--right"
              :title="item.createdAt"
            >
              {{ item.createdAt | formatDateDMYT }}
            </span>
          </button>
        </template>
      </template>

      <template v-else>
        <div class="app-list__li-like">
          <template v-if="isLoaded && !verificationsList.length">
            <p>
              {{ "user-verifications.nothing-here-yet" | globalize }}
            </p>
          </template>

          <template v-else-if="isFailed">
            <p>
              {{ "user-verifications.default-error-message" | globalize }}
            </p>
          </template>

          <template v-else>
            <p>
              {{ "user-verifications.loading-message" | globalize }}
            </p>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ErrorHandler } from '@/js/helpers/error-handler'
import { clearObject } from '@/js/helpers/clear-object'
import { api } from '@/api'
import { vueRoutes } from '@/vue-router/routes'
import { VerificationRecord } from '@/js/records/entities/verification.record'
import Copyable from '@/vue/common/copyable/Copyable'

export default {
  name: 'user-verifications',
  components: {
    'copyable': Copyable,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      isLoaded: false,
      isFailed: false,
      isPending: false,
      verificationsList: [],
      pendingVerifications: [],
    }
  },

  async created () {
    await this.getVerifications()
    this.filterVerifications()
  },
  methods: {
    async getVerifications () {
      this.isLoaded = false
      this.isFailed = false
      let response = {}
      try {
        const query = {
          filter: clearObject({
            user_id: this.id,
          }),
        }

        const { data } = await api.getWithSignature('/verifications', query)
        this.verificationsList = data.map(i => new VerificationRecord(i))
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      }

      this.isLoaded = true
      return response
    },

    filterVerifications () {
      this.pendingVerifications = this.verificationsList.filter(item => item.status === 'pending_manual')
    },

    redirectToVerificationDetails (id) {
      this.$router.push({
        name: vueRoutes.verificationDetails.name,
        params: { id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-verifications__list-title {
  margin: 1rem 0 2rem 2rem;
}

.user-verifications__list-title__top-padded {
  margin: 3rem 0 2rem 2rem;
}
</style>
